var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookIcon = function SvgFacebookIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475993",
    d: "M22.496 0H3.504A3.504 3.504 0 0 0 0 3.504v18.992A3.504 3.504 0 0 0 3.504 26h9.367l.016-9.291h-2.414a.57.57 0 0 1-.57-.567l-.011-2.995a.57.57 0 0 1 .57-.572h2.409V9.681c0-3.358 2.05-5.187 5.047-5.187h2.458a.57.57 0 0 1 .57.57v2.525a.57.57 0 0 1-.57.57h-1.509c-1.629 0-1.944.775-1.944 1.91v2.506h3.58a.57.57 0 0 1 .565.637l-.355 2.994a.57.57 0 0 1-.565.503h-3.21L16.924 26h5.574A3.504 3.504 0 0 0 26 22.497V3.504A3.504 3.504 0 0 0 22.496 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIcon);
export default ForwardRef;